import { Navigate } from 'react-router-dom';

/** Preserve the old bookmark, but keep Tutor guidance in the authenticated parent product. */
export function StudyTutorGuidePage() {
  return <Navigate to="/portal/study?view=method" replace />;
}
